import React from 'react'

const SAHelpButton = props => {
  return props.ineligibleForSAHelpInd === 'Y' ? null : (
    <div className="question-group question-group-divider">
      <h3>Access a study assist loan (SA-HELP)</h3>

      <div className="financial-content">
        <p>
          SA-HELP is a loan from the government to help you pay your student services and amenities fee (SSAF). For more information on the SSAF and what this fee covers at VU, go{' '}
          <a href={props.ssafLink} target="_blank">
            here
          </a>
          .
        </p>

        <p>
          You may be eligible for an <b>SA-HELP</b> loan – apply here
        </p>

        <p>
          <a className={`btn btn-financial-margin btn-financial-small btn-primary center ${props.isHelpSubmitted === 'Y' ? 'disabled-link' : ''}`} href={props.link}>
            Apply
          </a>
        </p>

        <p>Alternatively, you’ll be required to pay your SSAF by the due date.</p>        
      </div>
    </div>
  )
}

export default SAHelpButton